import { render } from "./EditarRoles.vue?vue&type=template&id=60191554"
import script from "./EditarRoles.vue?vue&type=script&lang=js"
export * from "./EditarRoles.vue?vue&type=script&lang=js"

import "./EditarRoles.vue?vue&type=style&index=0&id=60191554&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__